import { Flex, FlexProps, Image, ImageProps } from '../../../atoms';

type Props = {
  imgProps: ImageProps;
} & FlexProps;

export function SideOverlayHeaderImg({
  imgProps,
  ...rest
}: Props): JSX.Element {
  return (
    <Flex {...rest}>
      <Image {...imgProps} />
    </Flex>
  );
}
